import { ColumnDetails, ColumnValue } from '../../../grid/types/common';
import { CategoriesConfig } from '../../../grid/genericGridSmartViews/types';
import { EASMAssetsInventoryNavigationParams } from '@nirvana/shared/navigation';
import { EasmFinding, FindingType } from '../../types';
import { ListItem } from '../../../ui/gzSingleSelectList/types';

export const UPDATE_INCLUDED_ASSETS_METHOD = 'updateIncludedAssets';
export const UPDATE_EXCLUDED_ASSETS_METHOD = 'updateExcludedAssets';

export interface Permissions {
  canHaveChildCompanies: boolean;
}

export interface Dependencies {
  api: {
    type: string;
  };
  translateFn: Function;
  getTimezone: Function;
  getUserLanguage: Function;
  permissions: Permissions;
  getUser: Function;
  getActiveCompany: Function;
  navigationParams: EASMAssetsInventoryNavigationParams | null;
  openEndpointDetailsWindow(endpointId: string): void;
}

export interface IncludeExcludeAsset {
  type: FindingType;
  value: string;
}

export enum AssetAction {
  INCLUDE = 1,
  EXCLUDE = 2,
}

export enum NextScanInclusionStatus {
  DEFAULT = 0,
  INCLUDED = 1,
  EXCLUDED = 2,
}
export const SMART_VIEW_MAX_INPUT_LENGTH = 64;

export enum Column {
  NAME,
  TYPE,
  INVESTIGATION_STATUS,
  ASSIGNEE,
  PRIORITY,
  NEXT_SCAN_STATUS,
  CERTIFICATE_REPORTS_EXPIRATION_STATUS,
  SERVICES_PORT,
  SERVICES_CVES,
  COMPANY,
  VULNERABLE_TO_ZONE_TRANSFER,
  ASSETS_RELATED_TO_ASSET,
  DNS_RESOLUTION_STATUS,
  NOTES,
  ARTIFACTS_RELATED_TO_ASSET,
  NEW_ASSETS,
  CHANGE_PROPERTY_ACTIONS,
}

export enum ColumnKeys {
  NAME = 'name',
  COMPANY = 'company',
  TYPE = 'type',
  INVESTIGATION_STATUS = 'investigationStatus',
  ASSIGNEE = 'assignee',
  PRIORITY = 'priority',
  NEXT_SCAN_STATUS = 'nextScanStatus',
  CERTIFICATE_REPORTS_EXPIRATION_STATUS = 'expirationStatusFromArtifacts',
  SERVICES_OPEN_PORTS = 'openPorts',
  SERVICES_CVES = 'cvesFromRelatedArtifacts',
  VULNERABLE_TO_ZONE_TRANSFER = 'relatedArtifactAreVulnerable',
  ASSETS_RELATED_TO_ASSET = 'assetsRelatedToAsset',
  DNS_RESOLUTION_FAILS = 'dnsResolutionFailed',
  NOTES = 'notes',
  ARTIFACTS_RELATED_TO_ASSET = 'artifactsRelatedToAsset',
  NEW_ASSETS = 'new',
  CHANGE_PROPERTY_ACTIONS = 'changePropertyActions',
}

export interface EasmAssetsInventoryGridViewData {
  smartViewsCategories: CategoriesConfig;
  allColumns: Array<ColumnDetails<Column, ColumnKeys>>;
  predefinedFilterKeys: Array<ColumnKeys>;
  scanActionOptions: ListItem[];
  investigationStatusOptions: (ColumnValue | ListItem)[];
  assigneeOptions: ListItem[];
  priorityOptions: (ColumnValue | ListItem)[];
}

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 100;

export interface EasmAssetsInventoryGridResponse {
  data: Array<EasmFinding>;
  total: number;
}

export interface EasmAssetsInventoryGridGetRowsResponse {
  rawEvents: Array<EasmFinding>;
}

export enum ScanAction {
  INCLUDE_IN_SCAN = 1,
  EXCLUDE_FROM_SCAN = 2
}
